<template>
  <div class="activeContainer" ref="activeContainer">
    <div class="back" @click="goBack"><i></i></div>
    <div class="clubHead">
      <img :src="clubActiveDeatil.clubHead" alt="" />
    </div>
    <div class="activeTitle">
      <h2>{{ clubActiveDeatil.title }}</h2>
      <p class="time">
        <i class="icon-time"></i>
        {{ $dayJs(clubActiveDeatil.activeStartTime).format('YYYY-MM-DD') }} -
        {{ $dayJs(clubActiveDeatil.activeEndTime).format('YYYY-MM-DD') }}
      </p>
      <p class="address">
        <i class="icon-address"></i> {{ clubActiveDeatil.address }}
      </p>
      <div
        class="commonstatus"
        :class="{
          isEnd: clubActiveDeatil.status == 4,
          isPending: clubActiveDeatil.status == 1,
          notStarted: clubActiveDeatil.status == 2,
          isProgress: clubActiveDeatil.status == 3,
        }"
      >
        {{
          clubActiveDeatil.status == 4
            ? '已结束'
            : clubActiveDeatil.status == 3
            ? '进行中'
            : clubActiveDeatil.status == 2
            ? '未开始'
            : '报名中'
        }}
      </div>
    </div>
    <div class="activeTab" ref="activeTab">
      <a
        class="tabItem"
        :href="tab.url"
        :class="{ active: tabType == tab.type }"
        v-for="tab in activeTabData"
        :key="tab.name"
        @click="tabClick(tab)"
      >
        <div>{{ tab.name }}</div>
        <i class="tabBorder"></i>
      </a>
    </div>
    <div class="visable" id="brilliant"></div>
    <div class="brilliant" ref="brilliant">
      <div class="commontitle">精彩现场</div>
      <div class="brilliantContainer">
        <img
          v-for="(url, index) in clubActiveDeatil.brilliantScene"
          :key="index"
          :src="url"
          alt=""
        />
      </div>
    </div>
    <div class="visable" id="activeRecord"></div>
    <div class="activeRecord" ref="activeRecord">
      <div class="commontitle">活动介绍</div>
      <div class="activeRecordContent">
        {{ clubActiveDeatil.activeIntroduction }}
      </div>
    </div>
    <div class="visable" id="activeAgenda"></div>
    <div class="activeAgenda" ref="activeAgenda">
      <div class="commontitle">活动议程</div>
      <div class="agendaContainer">
        <div
          class="agendaItem"
          v-for="item in clubActiveDeatil.timeLineData"
          :key="item.time"
        >
          <div class="time">{{ item.startTime }} - {{ item.endTime }}</div>
          <div class="itemContent">
            <p class="cicle"></p>
            <h3>{{ item.title }}</h3>
            <p>{{ item.record }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="visable" id="guestRecord"></div>
    <div class="guestRecord" ref="guestRecord">
      <div class="commontitle">嘉宾介绍</div>
      <div class="guestRecordContent">
        <div
          class="recordItem"
          v-for="(item, index) in clubActiveDeatil.specialGuests"
          :key="index"
        >
          <img :src="item.avatar" alt="" />
          <h3>{{ item.name }}</h3>
          <p>{{ item.company }}</p>
          <p>{{ item.position }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { clubActiveDatail } from '@/api'
export default {
  name: 'Active',
  data() {
    return {
      activeTabData: [
        { name: '精彩现场', type: 1, url: '#brilliant' },
        { name: '活动介绍', type: 2, url: '#activeRecord' },
        { name: '活动议程', type: 3, url: '#activeAgenda' },
        { name: '嘉宾介绍', type: 4, url: '#guestRecord' },
      ],
      tabType: 1,
      timeLineData: [],
      clubActiveDeatil: {
        releaseTime: '',
        address: '',
        activeStartTime: '',
        activeEndTime: '',
        city: '',
        title: '',
        imgUrl: '',
        clubHead: '',
        status: 1,
        activeIntroduction: '',
        specialGuests: [],
        timeLineData: [],
        brilliantScene: [],
      },
    }
  },
  mounted() {
    this.getActiveDeatil()
    this.flag = this.$refs.activeTab.offsetTop

    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {},
  methods: {
    tabClick(tab) {
      this.tabType = tab.type
    },
    handleScroll() {
      //获取滚动时的高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      let oneHeight = this.$refs.brilliant?.offsetTop
      let twoHeight = this.$refs.activeRecord.offsetTop
      let threeHeight = this.$refs.activeAgenda.offsetTop
      const ele = this.$refs.activeTab
      // console.log(scrollTop, threeHeight)

      if (scrollTop < oneHeight) {
        //滚动大于0的时候要做的操作
        this.tabType = 1
      }
      if (scrollTop >= this.flag) {
        if (!ele.classList.contains('fixed')) {
          ele.classList.add('fixed')
          this.$refs.activeContainer.classList.add('paddTop')
        }
      } else {
        ele.classList.remove('fixed')
        this.$refs.activeContainer.classList.remove('paddTop')
      }
      if (scrollTop > oneHeight) {
        this.tabType = 2
      }
      if (scrollTop > twoHeight) {
        this.tabType = 3
      }
      if (scrollTop > threeHeight) {
        this.tabType = 4
      }
    },
    goBack() {
      const route = this.$route.query
      if (route.path) {
        this.$router.push(route.path)
      } else {
        this.$router.push('/club')
      }
    },
    async getActiveDeatil() {
      this.clubActiveDeatil = await clubActiveDatail({
        id: this.$route.params.id,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  border-bottom: 1px solid #e5e5e5;
}
.paddTop {
  padding-top: 50px !important;
}
.visable {
  height: 0;
  position: relative;
  top: -50px;
}
.activeContainer {
  // height: 100vh;
  background-color: #f5f6f8;
  // overflow-y: auto;
  box-sizing: border-box;
  .clubHead {
    img {
      width: 100%;
      height: 211px;
    }
  }
  .activeTitle {
    position: relative;
    padding: 21px 17px 18px 17px;
    background-color: white;
    margin-bottom: 10px;
    h2 {
      font-size: 23px;
      color: #3e3e3e;
    }
    .commonstatus {
      border-bottom-right-radius: 0;
    }
    p {
      display: flex;
      align-items: center;
      font-size: 12px;
      font-weight: 400;
      color: #999ca1;
      margin-top: 15px;
      i {
        display: inline-block;
        width: 12px;
        height: 12px;
        background-size: cover;
        margin-right: 3px;
        &.icon-time {
          background-image: url('~@/assets/images/time.png');
        }
        &.icon-address {
          background-image: url('~@/assets/images/address.png');
        }
      }
    }
  }
  .activeTab {
    display: flex;
    justify-content: space-evenly;
    background: white;
    font-size: 14px;
    border-bottom: 1px solid #e5e5e5;

    .tabItem {
      position: relative;
      padding: 17px 0;
      color: #222222;
      text-decoration: none;
      .tabBorder {
        position: absolute;
        left: 50%;
        bottom: 0;
        display: none;
        width: 28px;
        height: 3px;
        margin-left: -14px;
        background: #4c8bff;
        border-radius: 3px;
      }
      &.active {
        color: #4c8bff;
        .tabBorder {
          display: block;
        }
      }
    }
  }
  .commontitle {
    font-size: 16px;
    font-weight: bold;
    color: #9b9ea3;
    padding-left: 5px;
    border-left: 2.5px solid #328cff;
    letter-spacing: 2px;
  }
  .brilliant {
    padding: 25px 17px 16px 17px;
    background-color: white;

    .brilliantContainer {
      width: 100%;
      height: 92px;
      overflow-x: auto;
      overflow-y: hidden;
      margin-top: 21px;
      white-space: nowrap;
      img {
        width: 140px;
        height: 92px;
        margin-right: 10px;
      }
    }
  }
  .activeRecord {
    padding: 25px 17px 16px 17px;
    background-color: white;
    margin-top: 10px;
    .activeRecordContent {
      padding: 16px;
      margin-top: 15px;
      background: #eaf3ff;
      border: 1px solid #cce2ff;
      border-radius: 9px;
      font-size: 14px;
      color: #3f3f3f;
      line-height: 24px;
    }
  }
  .guestRecord {
    margin-top: 10px;
    padding: 25px 17px 16px 17px;
    background-color: white;
    .guestRecordContent {
      margin: 20px 17px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      img {
        width: 80px;
        height: 80px;
        border-radius: 100%;
      }
      .recordItem {
        text-align: center;
        margin-bottom: 30px;
        &:nth-child(3n + 0) {
          margin-right: 0;
        }
        h3 {
          font-size: 16px;
          font-weight: 400;
          color: #222222;
          margin: 18px 0 10px 0;
        }
        p {
          font-size: 12px;
          font-weight: 400;
          color: #9b9ea3;

          margin-bottom: 5px;
        }
      }
    }
  }
  .activeAgenda {
    padding: 25px 17px 16px 17px;
    background-color: white;
    margin-top: 10px;
    .agendaContainer {
      margin-top: 23px;
      .agendaItem {
        display: flex;
        align-items: flex-start;
        &:last-child {
          .itemContent {
            border-left: none;
          }
        }
        .time {
          width: 75px;
          font-size: 12px;
          font-weight: 400;
          color: #999ca1;
        }
        .itemContent {
          position: relative;
          flex: 1;
          display: flex;
          flex-direction: column;
          margin: 0 0 0 15px;
          padding: 0 0 20px 15px;
          border-left: 1px solid #e5e5e5;

          p.cicle {
            position: absolute;
            left: -6.5px;
            top: 0;
            margin: 0;
            z-index: 10;
            width: 9px;
            height: 9px;
            background: #ffffff;
            border: 1.5px solid #328cff;
            border-radius: 50%;
          }
          h3 {
            font-size: 16px;
            color: #3f3f3f;
            margin-top: -7px;
            line-height: 27px;
          }
          p {
            font-size: 12px;
            color: #999ca1;
            margin-top: 10px;
          }
        }
      }
    }
  }
}
</style>
